import { useMemo } from 'react';
import { FormScreenContent } from './form-screen-content.tsx';
import { useFormScreenModel } from '../hooks/use-form-screen-model.ts';
import { useFormScreenRuntime } from '../hooks/use-form-screen-runtime.ts';
import { FormScreenStateStore } from '../form-screen-state.ts';

/**
 * Form Screen renders server-loaded form components and hydrates client-side
 * validation, actions, and field state through the shared UI component pipeline.
 */
export function FormScreen(): JSX.Element {
  const stateStore = useMemo(() => new FormScreenStateStore(), []);
  const { formDataModel, uiComponents, serverLoadedFeeds, loadError } =
    useFormScreenModel({ stateStore });

  useFormScreenRuntime({ formDataModel, stateStore });

  if (loadError) {
    return (
      <div
        role="alert"
        className="mx-4 my-8 rounded border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800"
      >
        {loadError}
      </div>
    );
  }

  return (
    <FormScreenContent
      uiComponents={uiComponents}
      serverLoadedFeeds={serverLoadedFeeds}
    />
  );
}
